import { type FunctionComponent, useState } from "react";
import Input, { inputController0 } from "@/react/core/Input";
import TableManualKeyboard from "@/react/core/TableManualKeyboard";
import {
  filtersDelivery,
  setFiltersDelivery,
  setFilterV
} from "@/react/DeliveryManagementView/DeliveryManagementLogic.tsx";
import { useSignal } from "@/react/core/reactive.ts";
import { LL0 } from "@/react/core/I18nService.tsx";

interface SearchIDProps {
  onClose?: () => void
}

const SearchID: FunctionComponent<SearchIDProps> = ({ onClose }) => {

  const [id, setId] = useSignal("")

  return (
    <div className="h-auto font-mulish overflow-hidden rounded-[8px] bg-white">
      <div className="flex flex-1  px-3 py-2 rounded-t-[8px] border-b border-[#e0e0e0]">
        <div className="flex-1 font-bold text-[16px] text-[#0051c1]">
          {LL0().deliveryManagement.searchId()}
        </div>
        <img src="/icon-close-popup-icon--grey@2x.png" className="w-[22px] h-[22px]" alt="" onClick={onClose} />
      </div>
      <div className="flex flex-col gap-2 p-3">
        <div className="w-full relative flex items-center">
          <Input
            className="w-full rounded-[6px]"
            value={id()}
            onChange={v => setId(v)}
          />
          <img src="/search-blue-icon@2x.png" className="w-5 h-5 absolute right-3" alt="" />
        </div>
        <TableManualKeyboard
          inputController={inputController0}
          onEnter={() => {
            if (!!id()) {
              const currentFilters = filtersDelivery();
              currentFilters.searchId = id();
              setFiltersDelivery(currentFilters);
              setFilterV(p => p + 1)
            }
            onClose?.()
          }}
        />
      </div>
    </div>
  )
}

export default SearchID;